import moment from 'moment';

/**
 * メンテナンス関連機能
 */
class MaintenanceUtil {
  // メンテナンス開始日時
  static maintenanceStartDate = new Date('2026-05-26T03:30:00+09:00');
  // メンテナンス終了日時
  static maintenanceFinishDate = new Date('2026-05-26T04:00:00+09:00');

  /**
   * メンテナンス期間中true
   * @returns boolean
   */
  static isMaintenance() {
    let currentDate = new Date();
    if (
      currentDate >= this.maintenanceStartDate &&
      currentDate < this.maintenanceFinishDate
    ) {
      return true;
    }
    return false;
  }

  /**
   * メンテナンス予定がある場合にtrue
   * メンテナンス終了時にfalse
   * @returns boolean
   */
  static isMaintenanceSchedule() {
    let currentDate = new Date();
    if (currentDate >= this.maintenanceFinishDate) {
      return false;
    }
    return true;
  }

  /**
   * メンテナンス期間を返す
   * @returns string
   */
  static maintenanceTerm() {
    let message = moment(this.maintenanceStartDate).format('YYYY/MM/DD HH:mm');
    message += '〜';
    message += moment(this.maintenanceFinishDate).format('YYYY/MM/DD HH:mm');
    return message;
  }
}

export default MaintenanceUtil;
